import React from 'react'

export default function ContentField(props) {
  let { content = '' } = props

  return (
    <div className="form-input form-input--content">
      {content ? <div className="form-input-content">{content}</div> : null}
    </div>
  )
}
